export default __webpack_public_path__ + "static/media/gallery_12.b56b02e0.jpg";